'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _FieldsetContext = require('../context/FieldsetContext');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITextInput = require('../input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _MeasureText = require('../utils/MeasureText');

var _decorators = require('../utils/propTypes/decorators');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getMinimumSearchMessage = function getMinimumSearchMessage(minimumSearchCount, value) {
  var valueLength = value ? value.length : 0;
  var charsNeeded = minimumSearchCount - valueLength;
  if (valueLength && charsNeeded > 0) {
    return _I18n2.default.text('salesUI.UISearchInput.minimumSearchMessage', {
      count: charsNeeded
    });
  }
  return null;
};

var UISearchInput = function (_PureComponent) {
  _inherits(UISearchInput, _PureComponent);

  function UISearchInput(props) {
    _classCallCheck(this, UISearchInput);

    var _this = _possibleConstructorReturn(this, (UISearchInput.__proto__ || Object.getPrototypeOf(UISearchInput)).call(this, props));

    _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          readOnly = _this$props.readOnly;

      if (readOnly) return;
      if (evt.key === 'Escape') {
        _this.triggerClear();
      }
      (0, _Functions.callIfPossible)(onKeyDown, evt);
    };

    _this.triggerClear = function () {
      var _this$props2 = _this.props,
          inputRef = _this$props2.inputRef,
          onChange = _this$props2.onChange;

      onChange((0, _SyntheticEvent2.default)(''));
      inputRef.current.focus();
    };

    _this.state = {
      minimumSearchMessageOverflows: false
    };
    return _this;
  }

  _createClass(UISearchInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var minimumSearchCount = this.props.minimumSearchCount;

      if (minimumSearchCount > 0) this.computeMinimumSearchMessageOverflow();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var minimumSearchCount = this.props.minimumSearchCount;

      if (minimumSearchCount > 0) this.computeMinimumSearchMessageOverflow();
    }
  }, {
    key: 'computeMinimumSearchMessageOverflow',
    value: function computeMinimumSearchMessageOverflow() {
      // Determine whether there's enough space to show the minimum search message inline (#2869)
      var inputRef = this.props.inputRef;

      if (!this._wrapperEl || !this._iconEl || !this._helpTextEl) return;
      var wrapperWidth = this._wrapperEl.offsetWidth - this._iconEl.offsetWidth;
      var searchMessageWidth = this._helpTextEl.offsetWidth;
      var textWidth = (0, _MeasureText.getTextWidth)(inputRef.current);
      var minimumSearchMessageOverflows = searchMessageWidth > wrapperWidth - textWidth;
      if (minimumSearchMessageOverflows !== this.state.minimumSearchMessageOverflows) {
        this.setState({
          minimumSearchMessageOverflows: minimumSearchMessageOverflows
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          clearable = _props.clearable,
          icon = _props.icon,
          inputClassName = _props.inputClassName,
          minimumSearchCount = _props.minimumSearchCount,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          size = _props.size,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['className', 'clearable', 'icon', 'inputClassName', 'minimumSearchCount', 'placeholder', 'readOnly', 'size', 'value']);

      var minimumSearchMessageOverflows = this.state.minimumSearchMessageOverflows;


      return _react2.default.createElement(
        _FieldsetContext.FieldsetContextConsumer,
        null,
        function (fieldsetContext) {
          var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);

          var computedClassName = (0, _classnames2.default)('private-search-control', { 'private-search-control--xl': shorthandSize === 'xl' }, className);

          var showClearButton = clearable && value && !readOnly;

          var minimumSearchMessage = getMinimumSearchMessage(minimumSearchCount, value);

          var renderedMinimumSearchMessage = minimumSearchMessage ? _react2.default.createElement(
            'span',
            {
              'aria-atomic': false,
              'aria-live': 'polite',
              className: (0, _classnames2.default)('private-search-control__help-text', {
                'private-search-control__help-text--hidden': minimumSearchMessageOverflows
              }),
              ref: function ref(_ref) {
                _this2._helpTextEl = _ref;
              }
            },
            minimumSearchMessage
          ) : null;

          var renderedSearchIcon = icon && !readOnly ? _react2.default.createElement(
            'span',
            {
              ref: function ref(_ref2) {
                _this2._iconEl = _ref2;
              }
            },
            _react2.default.createElement(_UIIcon2.default, {
              className: (0, _classnames2.default)('private-search-control__icon', {
                'private-search-control__icon--small': fieldsetContext.size === 'small',
                'private-search-control__icon--hidden': showClearButton
              }),
              name: 'search'
            })
          ) : null;

          var renderedClearButton = showClearButton ? _react2.default.createElement(
            _UIClickable2.default,
            {
              className: (0, _classnames2.default)('private-search-control__clear-button', {
                'private-search-control__clear-button--small': fieldsetContext.size === 'small'
              }),
              onClick: _this2.triggerClear,
              tabIndex: -1
            },
            _react2.default.createElement(_UIIcon2.default, { name: 'remove' })
          ) : null;

          return _react2.default.createElement(
            _UITooltip2.default,
            {
              open: !!(minimumSearchMessage && minimumSearchMessageOverflows),
              title: minimumSearchMessage
            },
            _react2.default.createElement(
              'div',
              {
                className: computedClassName,
                ref: function ref(_ref3) {
                  _this2._wrapperEl = _ref3;
                }
              },
              _react2.default.createElement(_UITextInput2.default, _extends({}, rest, {
                className: (0, _classnames2.default)('private-search-control__input', inputClassName),
                onKeyDown: _this2.handleKeyDown,
                placeholder: (0, _lazyEval2.default)(placeholder),
                readOnly: readOnly,
                value: value
              })),
              _react2.default.createElement(
                'span',
                { className: 'private-search-control__foreground' },
                renderedMinimumSearchMessage,
                renderedSearchIcon
              ),
              renderedClearButton
            )
          );
        }
      );
    }
  }]);

  return UISearchInput;
}(_react.PureComponent);

UISearchInput.propTypes = _extends({}, _UITextInput2.default.propTypes, {
  clearable: _propTypes2.default.bool.isRequired,
  icon: _propTypes2.default.bool.isRequired,
  inputClassName: _propTypes2.default.string,
  minimumSearchCount: _propTypes2.default.number.isRequired,
  size: _propTypes2.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['xl']), _propTypes2.default.oneOf(['default'])]).isRequired,
  type: (0, _decorators.hidden)(_UITextInput2.default.propTypes.type)
});

UISearchInput.defaultProps = _extends({}, _UITextInput2.default.defaultProps, {
  clearable: true,
  icon: true,
  minimumSearchCount: 0,
  placeholder: function placeholder() {
    return _I18n2.default.text('salesUI.UISearchInput.placeholder');
  },
  size: 'default',
  type: 'search',
  value: ''
});

UISearchInput.displayName = 'UISearchInput';

exports.default = (0, _ShareInput2.default)((0, _Controllable2.default)(UISearchInput));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/UISearchInput.js
// module id = 600
// module chunks = 177